// Wrapper around our Typography BoxHeadline
import withTypography from './withTypography'
import BoxHeadline from '../components/ui/Typography/BoxHeadline'

export default withTypography(BoxHeadline)
